export default {
  title: "Oops, someting unexpected happened",
  description:
    "Please restart the page or click on the “Return to Menu” button below.",
  custom_button: {
    return: "Return To Menu",
  },
};
